import {LeftArrowIcon} from "../icons";
import React from 'react'
import {navigate} from "gatsby-link";
import * as styles from './go-back.module.css'

export const GoBack = () => {
  const handleBack = () => {
    if (window.history.length  <= 2) {
      navigate('/')
    } else {
      navigate(-1)
    }
  }
  return (
    <a aria-label={'go back'} title={'go back'} onClick={handleBack} className={styles.back}>
      <LeftArrowIcon/>
      <span>Return</span>
    </a>
  )
}